import { useState, useEffect } from 'react';
import { apiClient } from '@/lib/api';

interface UseCreditsReturn {
  credits: {
    remaining: number;
    unlimited: boolean;
    payAsYouGoEnabled: boolean;
    keyId: string;
  } | null;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function useCredits(): UseCreditsReturn {
  const [credits, setCredits] = useState<UseCreditsReturn['credits']>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCredits = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const data = await apiClient.getCredits();
      setCredits({
        remaining: data.remaining,
        unlimited: data.unlimited,
        payAsYouGoEnabled: data.payAsYouGoEnabled,
        keyId: data.keyId,
      });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch credits');
      console.error('Error fetching credits:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCredits();
  }, []);

  return {
    credits,
    loading,
    error,
    refetch: fetchCredits
  };
}
